import { Course } from '@/components/CourseCard';
import HomeCourseCard from '@/components/HomeCourseCard';
import PageTitle from '@/components/PageTitle';
import ThemeWrapper from '@/components/ThemeWrapper';
import AppLayout from '@/layouts/AppLayout';
import { GraduationCap } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ContinueLearning from './Partials/ContinueLearning';

interface Category {
    id: number;
    name: string;
    courses: Course[];
}

interface Props {
    categories_with_courses?: Category[];
}

const HomeContent: React.FC<Props> = ({ categories_with_courses }) => {
    const { t } = useTranslation();

    const hasNoCourses =
        !categories_with_courses || categories_with_courses.length === 0;

    return (
        <AppLayout>
            <PageTitle title="Inicio" />
            <div className="mx-auto max-w-7xl space-y-6 lg:space-y-8">
                {/* Continue Learning Section */}
                <ContinueLearning />

                {hasNoCourses ? (
                    <div className="rounded-lg border border-gray-200 bg-white p-8 shadow-sm">
                        <div className="py-12 text-center">
                            <GraduationCap className="mx-auto mb-4 h-12 w-12 text-gray-400" />
                            <h3 className="mb-2 text-xl font-semibold text-gray-900">
                                {t('home.noCoursesEnrolled')}
                            </h3>
                            <p className="text-gray-600">
                                {t('home.exploreCatalog')}
                            </p>
                        </div>
                    </div>
                ) : (
                    categories_with_courses?.map((category) => (
                        <div key={category.id} className="space-y-6">
                            <h2 className="text-xl font-bold text-gray-900 sm:text-2xl">
                                {category.name}
                            </h2>
                            <div className="grid gap-4 sm:gap-6 md:grid-cols-2">
                                {category.courses.map((course) => (
                                    <HomeCourseCard
                                        key={course.id}
                                        course={course}
                                    />
                                ))}
                            </div>
                        </div>
                    ))
                )}
            </div>
        </AppLayout>
    );
};

const Home: React.FC<Props> = ({ categories_with_courses }) => {
    return (
        <ThemeWrapper>
            <HomeContent categories_with_courses={categories_with_courses} />
        </ThemeWrapper>
    );
};

export default Home;
